import * as React from "react";
import Stack from "@mui/material/Stack";
import TemplateFrame from "../signIn/TemplateFrame";
import MuiCard from "@mui/material/Card";
import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";
import Copyright from "../../components/Copyright";
import ForgotPassword from "../forgotPassword/ForgotPassword";
// import ForgotPasswordContent from "../forgotPassword/ForgotPasswordContent";

const Card = styled(MuiCard)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignSelf: "center",
  width: "900px",
  minHeight: "400px",
  backgroundColor: "#FFFFFF 0% 0% no-repeat padding-box",
  boxShadow: "0px 3px 6px #0000003C",
}));

export default function ForgotPasswordView() {
  return (
    <TemplateFrame>
      <Stack
        direction="column"
        component="main"
        sx={[
          {
            justifyContent: "space-between",
            height: { xs: "auto", md: "100%" },
          },
          (theme) => ({
            backgroundImage:
              "radial-gradient(ellipse at 70% 51%, hsl(210, 100%, 97%), hsl(0, 0%, 100%))",
            backgroundSize: "cover",
          }),
        ]}
      >
        <Stack
          direction={{ xs: "column-reverse", md: "row" }}
          sx={{
            justifyContent: "center",
            m: "auto",
          }}
        >
          <Card variant="outlined" sx={{ padding: 0 }}>
            <Box
              sx={{
                width: "380px",
                borderRight: "1px solid #D3D3D3",
                padding: 0,
              }}
            >
              <Box
                sx={{
                  display: { xs: "none", md: "block" },
                  m: 6,
                }}
              >
                {/* <ForgotPasswordContent /> */}
              </Box>
            </Box>
            <Box sx={{ width: "520px", padding: 0 }}>
              <Box sx={{ m: 8 }}>
                <ForgotPassword />
              </Box>
            </Box>
          </Card>
        </Stack>
        <Copyright sx={{ my: 4 }} />
      </Stack>
    </TemplateFrame>
  );
}
